import { shopify } from './shopify.js';
import { history } from './helpers.js';
import { collection } from './collection.js';

/**
 * Toggles sorting dropdown open/close
 */
const toggle = function (event) {
	if (!event) return;

	event.preventDefault();
	event.currentTarget.classList.toggle('active');
};

/**
 * Updates URL for sort direction
 * @param { object } event - user/event generated browser object
 */
const setSortData = async function (event) {
	if (!event) return;
	const value = event.target.value;
	const container = document.querySelector('[data-filter-name="sortby"]');

	let url = new URL(window.location);
	url.searchParams.set('sort_by', value);
	url = new URL(url);

	window.history.pushState({}, '', url);

	const res = await shopify.collection.filter(url);

	if (container) {
		container.classList.remove('active');
	}

	if (!res || (res && res.error) || (res && !res.data)) {
		error(res.error.message ? res.error.message : res.error);
		return;
	}

	await collection();
};

export const sort = function () {
	window.Solver.toggleSort = toggle;
	window.Solver.setSortData = setSortData;
};
